import React, { useEffect, useState, useRef, Fragment } from "react";
import ReactDOM from "react-dom";
import { StickyTable, Row, Cell } from "react-sticky-table";
import {
    Typography,
    Button,
    Tooltip,
    CircularProgress,
    Grid,
    IconButton,
} from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { api_host } from "../../../../../common/globals/constants";
import LightStatus from "../ObjectiveCell/LightStatus";
import { useTranslation } from "react-i18next";
import { reportFetchError } from "../../../../../observability/rum";
export const InvertedTable = ({
    objectivesList,
    nodesIdList,
    groupedNodes,
    filter,
    onCellClick,
    handleOpenObjectiveModal,
    filterTagsId,
    filterTagsType,
    fullScreenEl
}) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [results, setResults] = useState([]);

    const objectives = objectivesList.filter((objetivo) => {
        if (
            filter === "Todos" ||
            objetivo.estado === filter ||
            (filter === "Activos" && objetivo.estado !== "No monitoreo")
        ) {
            if (!objetivo.Etiquetas) return false

            if (!filterTagsId.length) {
                return objetivo;
            }

            let tieneEtiquetas = true

            if (filterTagsType === "AND") {
                for (const id of filterTagsId) {
                    if (!objetivo.Etiquetas.find(et => et.etiqueta_id === id)) {
                        tieneEtiquetas = false
                        break;
                    }
                }
            } else {
                tieneEtiquetas = objetivo.Etiquetas.filter(et => filterTagsId.includes(et.etiqueta_id)).length > 0
            }
            return tieneEtiquetas;
        }
    });

    const tableRef = useRef(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        let token = sessionStorage.getItem("key");
        let user = sessionStorage.getItem("user");
        let lightsPeriod = parseInt(sessionStorage.getItem("period_semaphore"));

        const fetchResults = await Promise.all(
            objectivesList.map(async (objetivo) => {
                const dataApi = await fetch(
                    api_host +
                        `/reporte/online/indicadores/getUltimoEstadoObjetivo/?user=${user}&objetivoId=${objetivo.objetivo_id}&objectiveName=${objetivo.nombre}&lightsPeriod=${lightsPeriod}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&timestamp=${new Date().getTime()}`
                )
                    .then((res) => {
                        return res.json();
                    })
                    .then((res) => {
                        return res;
                    })
                    .catch((error) => {
                        reportFetchError("InvertedTable", error);
                        return { Objetivo: { objetivo_id: objetivo.objetivo_id, Nodo: [] }, loadError: true };
                    });
                return { ...objetivo, ...dataApi };
            })
        );
        setIsLoading(false);
        setResults(fetchResults);
    };

    const processData = () => {
        let newListObjectives = filterTagsId.length ? [] : results;
        if (filterTagsId.length) {
            for (const state of results) {
                if (state) {
                    let tieneEtiquetas = true
                    if (filterTagsType === "AND") {
                        for (const id of filterTagsId) {
                            if (!state.Etiquetas.find(et => et.etiqueta_id === id)) {
                                tieneEtiquetas = false
                                break;
                            }
                        }
                    } else {
                        tieneEtiquetas = state.Etiquetas.filter(et => filterTagsId.includes(et.etiqueta_id)).length > 0
                    }
                    if (tieneEtiquetas) {
                        newListObjectives.push(state);
                    }
                }
            }
        }

        const groupByNodoId = nodesIdList.map((nodoId) => {
            let cell = [];
            for (const objetivo of newListObjectives) {
                if (
                    filter === "Todos" ||
                    objetivo.estado === filter ||
                    (filter === "Activos" && objetivo.estado !== "No monitoreo")
                ) {
                    let ok = false;
                    let cellData = {};
                    for (const node of objetivo.Objetivo.Nodo) {
                        if (nodoId == node.nodo_id && !ok) {
                            var colorEvent = "#41B900";
                            var icon = <LightStatus status="success" />;
                            var nameEvent = "Ok";
                            var descriptionEvent = "";
                            cellData["objective"] =
                                objetivo.Objetivo.objetivo_id;
                            cellData["interval"] = objetivo.intervalo;
                            cellData["node"] = node;
                            cellData["monitors"] = objetivo.Monitores;
                            cellData["status"] = node.Estado.nombre;
                            cellData["code"] = node.Estado.id;
                            if (node.Estado.id == 1) {
                                icon = <LightStatus status="success" />;
                                nameEvent = node.Estado.nombre;
                                descriptionEvent =
                                    "El objetivo actualmente esta uptime y sin eventos downtime durante todo en el período.";
                            } else if (node.Estado.id == 2) {
                                icon = <LightStatus status="error" />;
                                nameEvent = node.Estado.nombre;
                                colorEvent = "#C2272D";
                                descriptionEvent =
                                    "El objetivo actualmente esta en downtime.";
                            } else if (node.Estado.id == 3) {
                                icon = <LightStatus status="warning" />;
                                nameEvent = node.Estado.nombre;
                                colorEvent = "#ebeb34";
                                descriptionEvent =
                                    "El objetivo actualmente esta uptime pero con eventos downtime durante parte del período.";
                            } else if (node.Estado.id == 4) {
                                icon = <LightStatus status="none" />;
                                nameEvent = node.Estado.nombre;
                                colorEvent = " #A9A9A9";
                                descriptionEvent =
                                    "No se ha recibido nueva informaci&oacute;n del objetivo desde el ISP.";
                            } else if (node.Estado.id == 5) {
                                icon = <LightStatus status="none" />;
                                nameEvent = node.Estado.nombre;
                                colorEvent = " #A9A9A9";
                                descriptionEvent =
                                    "El objetivo actualmente no se esta monitoreando desde el ISP.";
                            } else if (node.Estado.id == 6) {
                                icon = <LightStatus status="none" />;
                                nameEvent = node.Estado.nombre;
                                colorEvent = " #A9A9A9";
                                descriptionEvent = "Evento Cliente.";
                            }
                            cellData["descriptionEvent"] = descriptionEvent;
                            cellData["nameEvent"] = nameEvent;
                            cellData["icon"] = icon;
                            cellData["color"] = colorEvent;
                            var duration = node.Estado.duracion;
                            if (duration.includes("days")) {
                                duration = duration.replace("days", "día(s)");
                            } else if (duration.includes("day")) {
                                duration = duration.replace("day", "día");
                            }
                            cellData["duration"] = duration;
                            cell.push(cellData);
                            ok = true;
                        }
                    }
                    if (!ok) {
                        cellData["status"] = "";
                        cellData["code"] = "";
                        cellData["duration"] = "";
                        cellData["color"] = "";
                        cellData["icon"] = "";
                        cellData["step"] = "";
                        cell.push(cellData);
                    }
                }
            }
            return { nodo: groupedNodes[nodoId][0], cells: cell };
        });

        return groupByNodoId;
    };

    const onCellClickInverted = ({ monitors, objective, interval, node }) => {
        let lightsPeriod = parseInt(sessionStorage.getItem("period_semaphore"));
        var endDate = new Date();
        endDate = endDate.getTime();
        var startDate = endDate - lightsPeriod * 1000;
        let point = [];
        point["x"] = startDate;
        point["x2"] = endDate;
        point["y"] = node;
        onCellClick(point, monitors, objective, interval);
    };

    const scroll = (scrollOffset) => {
        const scrollContainer = ReactDOM.findDOMNode(tableRef.current);
        scrollContainer.scrollLeft += scrollOffset;
    };

    const cellStyleInFullScreen = fullScreenEl ? {
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    } : {};

    const renderTable = () => (
        <StickyTable
            style={{ maxWidth: "100%" }}
            stickyHeaderCount={1}
            leftStickyColumnCount={2}
            ref={tableRef}
        >
            <Row>
                <Cell
                    style={{
                        backgroundColor: "#373537",
                        minWidth: "130px",
                        borderRight: "2px solid #e4dede",
                        ...cellStyleInFullScreen
                    }}
                >
                    <Typography
                        variant="h4"
                        style={{
                            color: "white",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {t('traffic-light-inverted.table.text.monitor')}
                    </Typography>
                </Cell>
                <Cell
                    style={{
                        backgroundColor: "#373537",
                        borderRight: "2px solid #e4dede",
                    }}
                ></Cell>
                {objectives.map((objetivo) => (
                    <Cell
                        key={objetivo.objetivo_id}
                        style={{
                            backgroundColor: "#373537",
                            minWidth: "250px",
                            maxWidth: "250px",
                            borderRight: "2px solid #e4dede",
                            ...cellStyleInFullScreen
                        }}
                    >
                        <Tooltip title={<div>
                                            <Typography variant="h5" style={{color:'white'}}>{objetivo.nombre}</Typography>
                                            </div>}>
                            <Button
                                onClick={() =>
                                    handleOpenObjectiveModal(
                                        objetivo.objetivo_id,
                                        objetivo.nombre
                                    )
                                }
                            >
                                <Typography
                                    variant="h5"
                                    style={{
                                        color: "white",
                                    }}
                                >
                                    {objetivo.nombre.substr(0,20)}
                                </Typography>
                            </Button>
                        </Tooltip>
                        {results.find((r) => r.objetivo_id === objetivo.objetivo_id)?.loadError ?
                            <Typography variant="caption" style={{ color: "white", display: "block" }}>{t("text.load-error")}</Typography>
                        : null}
                    </Cell>
                ))}
            </Row>
            {processData().map(({ nodo, cells }, index) => (
                <Fragment key={nodo.id_nodo}>
                    <Row>
                        <Cell
                            style={{
                                backgroundColor: "#bebebe",
                                maxWidth: "130px",
                                minWidth: "130px",
                                borderRight: "2px solid #e4dede",
                            }}
                        >
                            <Typography
                                align="left"
                                variant="h5"
                                style={{ color: "black" }}
                            >
                                {nodo.titulo.substr(0, 10)}
                            </Typography>
                        </Cell>
                        <Cell
                            style={{
                                backgroundColor: "#bebebe",
                                maxWidth: "130px",
                                minWidth: "130px",
                                borderRight: "2px solid #e4dede",
                                ...cellStyleInFullScreen
                            }}
                        >
                            <Typography
                                align="left"
                                style={{ color: "black" }}
                            >
                                {nodo.subtitulo.substr(0, 15)}
                            </Typography>
                        </Cell>
                        {cells.map((cell, i) => (
                            <Fragment key={`${nodo.id_nodo}${i}`}>
                                {cell.icon !== "" ? (
                                    <Tooltip
                                        title={
                                            <div>
                                                <Typography
                                                    variant="h4"
                                                    style={{
                                                        color:
                                                            "white",
                                                    }}
                                                >
                                                    {cell.nameEvent}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    style={{
                                                        color:
                                                            "white",
                                                    }}
                                                >
                                                    {
                                                        cell.descriptionEvent
                                                    }
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    style={{
                                                        color:
                                                            "white",
                                                    }}
                                                >
                                                    {t('traffic-light.popover.text.duration')+": "+cell.duration}
                                                </Typography>
                                            </div>
                                        }
                                        placement="bottom"
                                        arrow
                                    >
                                        <Cell
                                            style={{
                                                maxWidth: "130px",
                                                minWidth: "130px",
                                                borderBottom:
                                                    "2px solid #d4d4d4",
                                                borderRight:
                                                    "2px solid #e4dede",
                                                backgroundColor:
                                                    "#e9e9e9",
                                                ...cellStyleInFullScreen
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    height: "20px",
                                                }}
                                            >
                                                <Button
                                                    id={i}
                                                    onClick={() =>
                                                        onCellClickInverted(
                                                            {
                                                                monitors:
                                                                    cell.monitors,
                                                                objective:
                                                                    cell.objective,
                                                                interval:
                                                                    cell.interval,
                                                                node:
                                                                    nodo.nodo,
                                                            }
                                                        )
                                                    }
                                                >
                                                    {cell.icon}
                                                </Button>
                                            </Typography>
                                        </Cell>
                                    </Tooltip>
                                ) : (
                                    <Cell
                                        style={{
                                            maxWidth: "130px",
                                            minWidth: "130px",
                                            borderBottom:
                                                "2px solid #d4d4d4",
                                            borderRight:
                                                "2px solid #e4dede",
                                            backgroundColor:
                                                "#e9e9e9",
                                        }}
                                    />
                                )}
                            </Fragment>
                        ))}
                    </Row>
                </Fragment>
            ))}
        </StickyTable>
    );

    if (isLoading) {
        return (
            <div style={{ marginTop: "20px" }}>
                <Typography variant="h5">
                    <CircularProgress
                        variant="indeterminate"
                        size={24}
                        thickness={4}
                    />
                    {t('text.loading')}
                </Typography>
            </div>
        );
    }
    return (
        <>
            <Grid container>
                <Grid item lg={12} md={12} sm={12}>
                    <div style={{ 
                                        display: 'flex', 
                                        justifyContent: 'flex-end', 
                                        alignItems: 'center', 
                                        padding: '4px 8px', 
                                    }}>
                        <IconButton onClick={() => scroll(-516)}>
                            <NavigateBeforeIcon />
                        </IconButton>
                        <IconButton onClick={() => scroll(516)}>
                            <NavigateNextIcon />
                        </IconButton>
                        <Typography variant="body2" style={{ color: 'black', fontWeight: 600, marginLeft: 8 }}>
                            {objectives.length +" "+t('text.objectives')}
                        </Typography>
                    </div>
                    <div style={{ 
                        position: 'fixed',
                        bottom: '24px',
                        right: '280px', // Aumenta este valor (ej. 90px o 100px) para dejar espacio al otro botón
                        zIndex: 1000,
                        backgroundColor: '#ffffff',
                        borderRadius: '30px',
                        border: '1px solid #e0e0e0',
                        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
                        padding: '6px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        {/* 2. Botones de Navegación */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            <IconButton onClick={() => scroll(-516)} size="small">
                                <NavigateBeforeIcon fontSize="small"/>
                            </IconButton>
                            <IconButton onClick={() => scroll(516)} size="small">
                                <NavigateNextIcon fontSize="small"/>
                            </IconButton>
                        </div>
                        {/* 3. Contador de Monitores */}
                        <Typography variant="subtitle2" style={{ color: '#111', fontWeight: 600, whiteSpace: 'nowrap' }}>
                            {objectives.length + " " + t('text.objectives')}
                        </Typography>
                    </div>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    style={{
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    {renderTable()}
                </Grid>
            </Grid>
        </>
    );
};
